import $api from '@/http'

async function getInsuranceListsWithPagination({page, size, isPolice}, {
    dateEndStrahovanie,
    dateStartStrahovanie,
    fioOrYurLico,
    isFizLico,
    markaAuto,
    modelAuto,
    organisationId,
    pinOrInn,
    serialNumber,
    serieOrNumberTS,
    vidDocument,
    vinNumber
}) {
    return await $api.get('/insurance/list', {
        params: {
            pageNo: page,
            pageSize: size,
            isPolice: isPolice,
            dateEndStrahovanie,
            dateStartStrahovanie,
            fioOrYurLico,
            isFizLico,
            markaAuto,
            modelAuto,
            organisationId,
            pinOrInn,
            serialNumber,
            serieOrNumberTS,
            vidDocument,
            vinNumber
        }
    })
}

async function getInsuranceListsWithPaginationNeObrabotan({page, size}, {
    dateEndStrahovanie,
    dateStartStrahovanie,
    fioOrYurLico,
    isFizLico,
    markaAuto,
    modelAuto,
    organisationId,
    pinOrInn,
    serialNumber,
    serieOrNumberTS,
    vidDocument,
    vinNumber
}) {
    return await $api.get('/insurance/listNeobrabotan', {
        params: {
            pageNo: page,
            pageSize: size,
            dateEndStrahovanie,
            dateStartStrahovanie,
            fioOrYurLico,
            isFizLico,
            markaAuto,
            modelAuto,
            organisationId,
            pinOrInn,
            serialNumber,
            serieOrNumberTS,
            vidDocument,
            vinNumber
        }
    })
}

async function insuranceToArhive(id) {
    return await $api.post('/insurance/toArhive?insuranceId=' + id)
}

async function getInsuranceArhiveListsWithPagination({page, size, isPolice}, {
    dateEndStrahovanie,
    dateStartStrahovanie,
    fioOrYurLico,
    isFizLico,
    markaAuto,
    modelAuto,
    organisationId,
    pinOrInn,
    serialNumber,
    serieOrNumberTS,
    vidDocument,
    vinNumber
}) {
    return await $api.get('/insurance/listArhive', {
        params: {
            pageNo: page,
            pageSize: size,
            dateEndStrahovanie,
            dateStartStrahovanie,
            fioOrYurLico,
            isFizLico,
            markaAuto,
            modelAuto,
            organisationId,
            pinOrInn,
            serialNumber,
            serieOrNumberTS,
            vidDocument,
            vinNumber
        }
    })
}

async function getInsuranceById({id}) {
    return await $api.get('/insurance/getById', {
        params: {
            id,
        }
    })
}

async function createInsuranceApplication(formData) {
    return await $api.post('/insurance/create', formData)
}

async function editInsuranceApplication(formData) {
    return await $api.put('/insurance/update', formData)
}

function downloadZayavlenie(id) {
    return $api.get('/insurance/generateZayavleniePDF', {
        params: {
            id: id
        },
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
    })
}

function downloadPolice(id) {
    return $api.get('/insurance/generatePolicePDF', {
        params: {
            id: id
        },
        responseType: 'blob',
        onDownloadProgress: (progressEvent) => {
            let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        }
    })
}

async function insuranceApplicationCalculate({id}) {
    return await $api.get('/insurance/calculate', {
        params: {
            id: id,
        }
    })
}

async function insuranceConvertToPolice({blankId, date, insuranceId, userId}) {
    return await $api.post('/insurance/converToPolice', {}, {
        params: {
            blankId,
            date,
            insuranceId,
            userId,
        }
    })
}

async function importFizDatas(filialId, formData) {
    return await $api.post('/importExcel/import_fiz', formData, {
        params: {
            filialId
        },
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

async function importYurDatas(filialId, formData) {
    return await $api.post('/importExcel/import_ur', formData, {
        params: {
            filialId
        },
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

async function convertToPolic(insuranceId) {
    return await $api.post('/insurance/convertToPoliceById', {}, {
        params: {
            insuranceId
        }
    })
}

async function convertToPolicSetBlank({blankId, date, insuranceId, userId}) {
    return await $api.post('/insurance/converToPolice', {}, {
        params: {
            blankId, date, insuranceId, userId
        }
    })
}

async function rastorjenie({insuranceId, rasstorj, summRasstorj, isIsporchen}) {
    return await $api.post('/insurance/rasstorj', {}, {
        params: {
            insuranceId, rasstorj, summRasstorj, isIsporchen
        }
    })
}


async function addPoliceUterya({id}, body) {
    return await $api.put(`/insurance/policeUterya?id=${id}`, body)
}

async function porcha(params) {
    return await $api.get('/insurance/porcha', {
        params: {
            id: params.id,
            porcha: params.porcha
        }
    })
}

async function addOsobyeOtmetki(formData) {
    return await $api.post('/insurance/osobyeOtmetkiAdd', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

async function getPersonByPin(pin) {
    return await $api.get('/insurance/person/findPersonByPinOrInn', {
        params: {
            pin
        }
    })
}

async function checkPersonByPin(pinOrInn) {
    return await $api.get('/client/checkByPinIsInBlackList',  {
        params: {
            pinOrInn
        }
    })
}

async function getClientById(id) {
    return await $api.get('/client/getById', {
        params: {
            id
        }
    })
}

async function checkPoliseActualityById(insuranceId) {
    return await $api.get('/insurance/police/checkActualityOfPolice', {
        params: {
            insuranceId
        }
    })
}
async function getVehicleInfo(pin) {
    return await $api.get('/insurance/get-vehicle', {
        params: {
            pin
        }
    })
}
async function getLicense(pin) {
    return await $api.post('/insurance/post-license', {},{
        params: {
            pin
        }
    })
}

export default {
    getInsuranceListsWithPagination,
    getInsuranceListsWithPaginationNeObrabotan,
    getInsuranceArhiveListsWithPagination,
    insuranceToArhive,
    downloadZayavlenie,
    downloadPolice,
    createInsuranceApplication,
    editInsuranceApplication,
    getInsuranceById,
    insuranceApplicationCalculate,
    insuranceConvertToPolice,
    checkPersonByPin,
    importFizDatas,
    importYurDatas,
    convertToPolic,
    convertToPolicSetBlank,
    rastorjenie,
    porcha,
    addOsobyeOtmetki,
    getPersonByPin,
    getClientById,
    checkPoliseActualityById,
    addPoliceUterya,
    getVehicleInfo,
    getLicense
}
